import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  Documentzero_table_interface,
  Fatturab2b_adg_table_interface,
  Fatturab2b_extra_table_interface,
} from '@bludata/common-interfaces';
import { Documentzero__table_interface } from '@bludata/common-interfaces';
import { AppDispatch } from '..';
import { DefaultDocumentGridValue } from '../../documenti/data/DefaultDocumentGridValue';
import moment from 'moment';
import { ConfigurazioneDocumento } from '../../interface/ConfigurazioneDocumento';
import { defaultFormValues } from '../../documenti/data/DefaultFormValue';
import { FatturaSchema } from '../../documenti/documentiView/data/FatturaSchema';
import { NotaCreditoSchema } from '../../documenti/documentiView/data/NotaCreditoSchema';
import { AltroSchema } from '../../documenti/documentiView/data/AltroSchema';
import Documentzero_table_interface_schema from '../../interface/Documentzero_table_interface_schema';
import Datagrid_Schema_Interface from '../../interface/Datagrid_Schema_Interface';
import { DocumentoTrasportoSchema } from '../../documenti/documentiView/data/DocumentoTrasportoSchema';
import { dateFormat } from '../../utility_objects/const/costants';
import { GetDocumentExtra } from '../../interface/GetDocumentExtra';
import { DocumentoInfo } from '../../interface/DocumentoInfo';
import { getTablePaginationRequestProps } from '@bludata/hook-usetableloader';
import dayjs, { Dayjs } from 'dayjs';

let documentoWrapController: AbortController | null = null;

export interface Castelletto_interface {
  data: {
    codiceIva: string;
    imponibileIva: number;
    importoIva: number;
    iva: string;
  }[];
  totale?: number;
}

export interface Ricerca_Fattura {
  data: Documentzero_table_interface[];
  totale: number;
}

export interface DocumentiSliceState {
  document: Documentzero_table_interface[];
  documentTotal: number;
  documentList: Documentzero__table_interface[];
  documentSchema: Documentzero_table_interface_schema;
  castellettoIva?: Castelletto_interface;
  documentExtra: GetDocumentExtra;
  documentoInfo: DocumentoInfo;
  documentoB2b_extra: Fatturab2b_extra_table_interface[];
  documentoB2b_adg: Fatturab2b_adg_table_interface[];
  ricercaFatturaList: Ricerca_Fattura;
  datagridSchema: Datagrid_Schema_Interface;
  documentTipo: string;
  page: number;
  tabella: string;
  configurazioneDocumento: ConfigurazioneDocumento;
  loading: boolean;
  error: string;
  isEdit: boolean;
  preventDatagridEdit: boolean;
  filiale: string;
  sistemaTesseraSanitaria: boolean;
  consoleTelematica: boolean;
  consoleTelematicaFE: boolean;
  ricercaRagioneSociale: string;
  ricercaNumeroDocumento: string;
  ricercaMonthSelected: number | null;
  ricercaDataAnno: Dayjs;
}

const initialState: DocumentiSliceState = {
  document: [],
  documentTotal: 0,
  documentList: [],
  castellettoIva: { data: [], totale: 0 },
  documentExtra: null,
  documentoInfo: null,
  documentoB2b_extra: [],
  documentoB2b_adg: [],
  ricercaFatturaList: { data: [], totale: 0 },
  page: 0,
  tabella: '',
  loading: false,
  error: '',
  documentSchema: null,
  datagridSchema: {
    descrizioneArticolo: false,
    codiceABarre: false,
    quantita: false,
    sconto: false,
    prezzo: false,
    iva: false,
    prezziNetti: false,
    gruppo: false,
  },
  documentTipo: '',
  isEdit: false,
  configurazioneDocumento: null,
  preventDatagridEdit: false,
  filiale: '',
  sistemaTesseraSanitaria: false,
  consoleTelematica: false,
  consoleTelematicaFE: false,
  ricercaRagioneSociale: '',
  ricercaNumeroDocumento: '',
  ricercaMonthSelected: null,
  ricercaDataAnno: null,
};

const DocumentiSlice = createSlice({
  name: 'documenti',
  initialState,
  reducers: {
    setFiliale(state: DocumentiSliceState, action: PayloadAction<string>) {
      state.filiale = action.payload;
    },
    setLoading(state: DocumentiSliceState, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setPreventDatagridEdit(
      state: DocumentiSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.preventDatagridEdit = action.payload;
    },
    toggleEdit(state: DocumentiSliceState) {
      state.isEdit = !state.isEdit;
    },
    setError(state: DocumentiSliceState, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    setTabella(state: DocumentiSliceState, action: PayloadAction<string>) {
      state.tabella = action.payload;
    },

    setConfigurazioneDocumento(
      state: DocumentiSliceState,
      action: PayloadAction<ConfigurazioneDocumento>,
    ) {
      state.configurazioneDocumento = action.payload;
    },

    setPage(state: DocumentiSliceState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setRicercaFatturaList(
      state: DocumentiSliceState,
      action: PayloadAction<Ricerca_Fattura>,
    ) {
      state.ricercaFatturaList.data = action.payload.data;
      state.ricercaFatturaList.totale = action.payload.totale;
    },
    setCastellettoIva(
      state: DocumentiSliceState,
      action: PayloadAction<Castelletto_interface>,
    ) {
      state.castellettoIva.data = action.payload.data;
      state.castellettoIva.totale = action.payload.totale;
    },
    setDocumentList(
      state: DocumentiSliceState,
      action: PayloadAction<Documentzero__table_interface[]>,
    ) {
      state.documentList = action.payload;
    },
    setDcumentExtra(
      state: DocumentiSliceState,
      action: PayloadAction<GetDocumentExtra>,
    ) {
      state.documentExtra = action.payload;
    },
    setDocumentoInfo(
      state: DocumentiSliceState,
      action: PayloadAction<DocumentoInfo>,
    ) {
      state.documentoInfo = action.payload;
    },
    setDocumentiB2b_extra(
      state: DocumentiSliceState,
      action: PayloadAction<Fatturab2b_extra_table_interface[]>,
    ) {
      state.documentoB2b_extra = action.payload;
    },
    setDocumentiB2b_adg(
      state: DocumentiSliceState,
      action: PayloadAction<Fatturab2b_adg_table_interface[]>,
    ) {
      state.documentoB2b_adg = action.payload;
    },
    setDocument(
      state: DocumentiSliceState,
      action: PayloadAction<Documentzero_table_interface[]>,
    ) {
      state.document = action.payload;
    },
    setDocumentSchema(
      state: DocumentiSliceState,
      action: PayloadAction<Documentzero_table_interface_schema>,
    ) {
      state.documentSchema = action.payload;
    },
    setDatagridSchema(
      state: DocumentiSliceState,
      action: PayloadAction<Datagrid_Schema_Interface>,
    ) {
      state.datagridSchema = action.payload;
    },
    setDocumentTipo(state: DocumentiSliceState, action: PayloadAction<string>) {
      state.documentTipo = action.payload;
    },
    setDocumentoTotal(
      state: DocumentiSliceState,
      action: PayloadAction<number>,
    ) {
      state.documentTotal = action.payload;
    },
    resetDocumentoInitialState(state: DocumentiSliceState) {
      for (const key in state) {
        if (Object.prototype.hasOwnProperty.call(state, key)) {
          state[key] = initialState[key];
        }
      }
    },
    setSistemaTesseraSanitaria(
      state: DocumentiSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.sistemaTesseraSanitaria = action.payload;
    },
    setConsoleTelematica(
      state: DocumentiSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.consoleTelematica = action.payload;
    },
    setConsoleTelematicaFE(
      state: DocumentiSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.consoleTelematicaFE = action.payload;
    },
    setRicercaRagioneSociale(
      state: DocumentiSliceState,
      action: PayloadAction<string>,
    ) {
      state.ricercaRagioneSociale = action.payload;
    },
    setRicercaNumeroDocumento(
      state: DocumentiSliceState,
      action: PayloadAction<string>,
    ) {
      state.ricercaNumeroDocumento = action.payload;
    },
    setRicercaMonthSelected(
      state: DocumentiSliceState,
      action: PayloadAction<number | null>,
    ) {
      state.ricercaMonthSelected = action.payload;
    },
    setRicercaDataAnno(
      state: DocumentiSliceState,
      action: PayloadAction<Dayjs>,
    ) {
      state.ricercaDataAnno = action.payload;
    },
  },
});

export const loadEmptyDocument = (
  configurazioneDocumento?: ConfigurazioneDocumento,
) => {
  return (dispatch: AppDispatch) => {
    dispatch(setLoading(false));
    let schema = FatturaSchema;
    dispatch(setDocumentTipo(configurazioneDocumento.tipo));
    dispatch(setConfigurazioneDocumento(configurazioneDocumento));
    dispatch(setTabella(configurazioneDocumento.tabella));

    dispatch(
      setDatagridSchema({
        descrizioneArticolo: configurazioneDocumento.descrizioneArticolo,
        codiceABarre: configurazioneDocumento.codiceABarre,
        quantita: configurazioneDocumento.quantita,
        sconto: configurazioneDocumento.sconto,
        prezzo: configurazioneDocumento.prezzo,
        iva: configurazioneDocumento.iva,
        prezziNetti: configurazioneDocumento.prezziNetti,
        gruppo: configurazioneDocumento.gruppo === 'R' ? false : true,
      }),
    );

    switch (configurazioneDocumento.tipo) {
      case 'F':
        //!Fattura Dettaglio
        //!Fattura ingrosso
        //!Fattura acq
        //!Tax refound
        schema = FatturaSchema;
        break;
      case 'N':
        //!NotaCreditoDettaglio
        //!NotaCreditoAcq
        schema = NotaCreditoSchema;
        break;
      case 'X':
        //!Preventivo
        //!ricevuta professionale
        //!quietanza
        schema = AltroSchema;
        break;
      case 'D':
        //!Documento di carico
        //!Documento di trasporto
        schema = DocumentoTrasportoSchema;
        break;
      default:
        schema = FatturaSchema;
    }

    dispatch(setDocumentSchema(schema));
    dispatch(
      setDocument([
        {
          ...defaultFormValues,
        },
      ]),
    );
    dispatch(setCastellettoIva({ data: [], totale: 0 }));
    dispatch(setDocumentList([]));
    /*
    Rimosso su indicazione della Rossella, non si deve vedere una riga vuota
    dispatch(
      setDocumentList([
        { ...DefaultDocumentGridValue, id: new Date().getTime() },
      ]),
    );
    */
    dispatch(setDcumentExtra(null));
    dispatch(setDocumentoInfo(null));
    dispatch(setDocumentiB2b_extra([]));
    dispatch(setDocumentiB2b_adg([]));
    dispatch(setLoading(false));
  };
};

export const fetchDocumentoCodiceFiliale = (
  codiceFiliale: string,
  configurazioneDocumento: ConfigurazioneDocumento,
) => {
  return (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    axios
      .get(`/focusapi/documento/getDocumentoWrap`, {
        params: {
          tablename: configurazioneDocumento.tabella,
          _dc: new Date().getTime(),
          ...getTablePaginationRequestProps(0, 1),
          filter: JSON.stringify([
            {
              property: 'codiceFiliale',
              operator: '=',
              value: codiceFiliale,
            },
          ]),
        },
      })
      .then((response) => {
        dispatch(setLoading(false));
        let schema = FatturaSchema;
        dispatch(setDocumentTipo(configurazioneDocumento.tipo));
        dispatch(setConfigurazioneDocumento(configurazioneDocumento));
        dispatch(setTabella(configurazioneDocumento.tabella));

        dispatch(
          setDatagridSchema({
            descrizioneArticolo: configurazioneDocumento.descrizioneArticolo,
            codiceABarre: configurazioneDocumento.codiceABarre,
            quantita: configurazioneDocumento.quantita,
            sconto: configurazioneDocumento.sconto,
            prezzo: configurazioneDocumento.prezzo,
            iva: configurazioneDocumento.iva,
            prezziNetti: configurazioneDocumento.prezziNetti,
            gruppo: configurazioneDocumento.gruppo === 'R' ? false : true,
          }),
        );

        switch (configurazioneDocumento.tipo) {
          case 'F':
            //!Fattura Dettaglio
            //!Fattura ingrosso
            //!Fattura acq
            //!Tax refound
            schema = FatturaSchema;
            break;
          case 'N':
            //!NotaCreditoDettaglio
            //!NotaCreditoAcq
            schema = NotaCreditoSchema;
            break;
          case 'X':
            //!Preventivo
            //!ricevuta professionale
            //!quietanza
            schema = AltroSchema;
            break;
          case 'D':
            //!Documento di carico
            //!Documento di trasporto
            schema = DocumentoTrasportoSchema;
            break;
          default:
            schema = FatturaSchema;
        }

        dispatch(setDocumentSchema(schema));

        if (!response.data.Success || response.data.documento.total === 0) {
          dispatch(loadEmptyDocument(configurazioneDocumento));
        } else {
          const newRows = { ...response.data.documento.data[0] };

          for (const key in newRows) {
            //!in ogni caso non sovrascrivo il campo id e codice filiale
            if (!schema[key] && schema[key] !== undefined) {
              newRows[key] = defaultFormValues[key];
            }
          }

          dispatch(setDocument([{ ...defaultFormValues, ...newRows }]));
          dispatch(setDocumentoTotal(response.data.documento.total));
          dispatch(
            setCastellettoIva({
              data: response.data.CastellettoIva.filter(
                (x) => x.imponibileIva !== null,
              ),
              totale: response.data.documento.data[0].totale
                ? response.data.documento.data[0].totale
                : 0,
            }),
          );
          dispatch(
            setDocumentList(
              response.data.righe.data.length ? response.data.righe.data : [],
            ),
          );
          dispatch(setDcumentExtra(response.data.DocumentExtraInfo));
          dispatch(setDocumentoInfo(response.data.documentoInfo));
          dispatch(setDocumentiB2b_extra(response.data.b2bExtra));
          dispatch(setDocumentiB2b_adg(response.data.b2bAltriDatiGestionali));

          dispatch(
            setDatagridSchema({
              descrizioneArticolo: configurazioneDocumento.descrizioneArticolo,
              codiceABarre: configurazioneDocumento.codiceABarre,
              quantita: configurazioneDocumento.quantita,
              sconto: configurazioneDocumento.sconto,
              prezzo: configurazioneDocumento.prezzo,
              iva: configurazioneDocumento.iva,
              prezziNetti: configurazioneDocumento.prezziNetti,
              gruppo: configurazioneDocumento.gruppo === 'R' ? false : true,
            }),
          );
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          // Ignora gli errori dovuti a richieste annullate
          dispatch(setLoading(false));
          dispatch(setError(err ? err : 'Internal server error'));
        }
      })
      .finally(() => {
        // Resetta il controller se questa è l'ultima chiamata completata
        if (documentoWrapController) {
          documentoWrapController = null;
        }
      });
  };
};

export const fetchDocumenti = (
  paginate: boolean,
  tabella: string,
  page: number,
  filiale: string,
  ragioneSociale?: string,
  numeroDocumento?: string,
  data?: string,
  configurazioneDocumento?: ConfigurazioneDocumento,
  meseSelezionato?: number,
) => {
  return (dispatch: AppDispatch) => {
    const pageSize = paginate ? 25 : 1;

    const arrayFilters = [
      {
        property: 'filiale',
        operator: '=',
        value: filiale,
      },
      {
        property: 'data',
        operator: '>',
        date: true,
        value: new Date(0),
      },
    ];

    if (data) {
      const newDate = new Date(data);
      const year = newDate.getFullYear();
      let firstDay = new Date(year, 0, 1, 0, 0, 0);
      let lastDay = new Date(year, 12, 0, 0, 0, 0);

      if (meseSelezionato) {
        firstDay = new Date(year, meseSelezionato, 1, 1, 0, 0, 0);
        lastDay = new Date(year, meseSelezionato + 1, 1, 0, 0, 0);
      }

      arrayFilters.push(
        {
          operator: '>=',
          property: 'data',
          value: firstDay,
          date: true,
        },
        {
          operator: '<=',
          property: 'data',
          value: lastDay,
          date: true,
        },
      );
    }

    if (ragioneSociale) {
      arrayFilters.push({
        property: 'ragioneSociale',
        value: ragioneSociale,
        operator: 'fulltext',
      });
    }

    if (numeroDocumento) {
      arrayFilters.push({
        property: 'numero',
        value: numeroDocumento,
        operator: 'fulltext',
      });
    }

    // Annulla richiesta precedente se esiste
    if (documentoWrapController) {
      documentoWrapController.abort();
    }

    // Crea un nuovo controller
    documentoWrapController = new AbortController();
    const signal = documentoWrapController.signal;

    dispatch(setLoading(true));
    axios
      .get(`/focusapi/documento/getDocumentoWrap`, {
        params: {
          _dc: new Date().getTime(),
          tablename: tabella,
          ...getTablePaginationRequestProps(page, pageSize),
          sort: JSON.stringify([
            {
              property: 'filiale',
              direction: 'DESC',
            },
            {
              property: 'data',
              direction: 'DESC',
            },
            {
              property: 'id',
              direction: 'DESC',
            },
          ]),
          filter: filiale === '-1' ? undefined : JSON.stringify(arrayFilters),
        },
        signal, // Aggiungiamo il signal per gestire l'annullamento
      })
      .then((response) => {
        dispatch(setLoading(false));
        let schema = FatturaSchema;
        dispatch(setDocumentTipo(configurazioneDocumento.tipo));
        dispatch(setConfigurazioneDocumento(configurazioneDocumento));
        dispatch(setTabella(tabella));

        dispatch(
          setDatagridSchema({
            descrizioneArticolo: configurazioneDocumento.descrizioneArticolo,
            codiceABarre: configurazioneDocumento.codiceABarre,
            quantita: configurazioneDocumento.quantita,
            sconto: configurazioneDocumento.sconto,
            prezzo: configurazioneDocumento.prezzo,
            iva: configurazioneDocumento.iva,
            prezziNetti: configurazioneDocumento.prezziNetti,
            gruppo: configurazioneDocumento.gruppo === 'R' ? false : true,
          }),
        );

        switch (configurazioneDocumento.tipo) {
          case 'F':
            //!Fattura Dettaglio
            //!Fattura ingrosso
            //!Fattura acq
            //!Tax refound
            schema = FatturaSchema;
            break;
          case 'N':
            //!NotaCreditoDettaglio
            //!NotaCreditoAcq
            schema = NotaCreditoSchema;
            break;
          case 'X':
            //!Preventivo
            //!ricevuta professionale
            //!quietanza
            schema = AltroSchema;
            break;
          case 'D':
            //!Documento di carico
            //!Documento di trasporto
            schema = DocumentoTrasportoSchema;
            break;
          default:
            schema = FatturaSchema;
        }

        dispatch(setDocumentSchema(schema));

        if (!response.data.Success || response.data.documento.total === 0) {
          dispatch(loadEmptyDocument(configurazioneDocumento));
        } else {
          dispatch(setPage(page));
          const newRows = { ...response.data.documento.data[0] };

          for (const key in newRows) {
            //!in ogni caso non sovrascrivo il campo id e codice filiale
            if (!schema[key] && schema[key] !== undefined) {
              newRows[key] = defaultFormValues[key];
            }
          }

          dispatch(setDocument([{ ...defaultFormValues, ...newRows }]));
          dispatch(setDocumentoTotal(response.data.documento.total));
          dispatch(
            setCastellettoIva({
              data: response.data.CastellettoIva.filter(
                (x) => x.imponibileIva !== null,
              ),
              totale: response.data.documento.data[0].totale
                ? response.data.documento.data[0].totale
                : 0,
            }),
          );
          dispatch(
            setDocumentList(
              response.data.righe.data.length ? response.data.righe.data : [],
            ),
          );
          dispatch(setDcumentExtra(response.data.DocumentExtraInfo));
          dispatch(setDocumentoInfo(response.data.documentoInfo));
          dispatch(setDocumentiB2b_extra(response.data.b2bExtra));
          dispatch(setDocumentiB2b_adg(response.data.b2bAltriDatiGestionali));

          dispatch(
            setDatagridSchema({
              descrizioneArticolo: configurazioneDocumento.descrizioneArticolo,
              codiceABarre: configurazioneDocumento.codiceABarre,
              quantita: configurazioneDocumento.quantita,
              sconto: configurazioneDocumento.sconto,
              prezzo: configurazioneDocumento.prezzo,
              iva: configurazioneDocumento.iva,
              prezziNetti: configurazioneDocumento.prezziNetti,
              gruppo: configurazioneDocumento.gruppo === 'R' ? false : true,
            }),
          );
          dispatch(setLoading(false));
        }
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          // Ignora gli errori dovuti a richieste annullate
          dispatch(setLoading(false));
          dispatch(setError(err ? err : 'Internal server error'));
        }
      })
      .finally(() => {
        // Resetta il controller se questa è l'ultima chiamata completata
        if (documentoWrapController) {
          documentoWrapController = null;
        }
      });
  };
};

export const nextDocumenti = (
  paginate: boolean,
  tabella: string,
  page: number,
  filiale: string,
  ragioneSociale: string,
  numeroDocumento: string,
  data: string,
  configurazioneDocumento: ConfigurazioneDocumento,
  meseSelezionato?: number,
) => {
  return (dispatch: AppDispatch) => {
    dispatch(setPage(page + 1));
    dispatch(
      fetchDocumenti(
        paginate,
        tabella,
        page + 1,
        filiale,
        ragioneSociale,
        numeroDocumento,
        data,
        configurazioneDocumento,
        meseSelezionato,
      ),
    );
  };
};

export const lastDocumenti = (
  paginate: boolean,
  tabella: string,
  filiale: string,
  ragioneSociale: string,
  numeroDocumento: string,
  data: string,
  configurazioneDocumento: ConfigurazioneDocumento,
  meseSelezionato?: number,
) => {
  return (dispatch: AppDispatch) => {
    dispatch(setPage(0));
    dispatch(
      fetchDocumenti(
        paginate,
        tabella,
        0,
        filiale,
        ragioneSociale,
        numeroDocumento,
        data,
        configurazioneDocumento,
        meseSelezionato,
      ),
    );
  };
};

export const prevDocumenti = (
  paginate: boolean,
  tabella: string,
  page: number,
  filiale: string,
  ragioneSociale: string,
  numeroDocumento: string,
  data: string,
  configurazioneDocumento: ConfigurazioneDocumento,
  meseSelezionato?: number,
) => {
  return (dispatch: AppDispatch) => {
    dispatch(setPage(page - 1));
    dispatch(
      fetchDocumenti(
        paginate,
        tabella,
        page - 1,
        filiale,
        ragioneSociale,
        numeroDocumento,
        data,
        configurazioneDocumento,
        meseSelezionato,
      ),
    );
  };
};

export const newDocument = (document: Documentzero_table_interface) => {
  return (dispatch: AppDispatch) => {
    //dispatch(setPage(1)); Facendo così mi carica dopo il nuovo sempre il penultimo articolo
    dispatch(
      setDocument([
        { ...document, data: moment(new Date()).format(dateFormat) },
      ]),
    );
    dispatch(setCastellettoIva({ data: [], totale: 0 }));
    dispatch(
      setDocumentList([
        { ...DefaultDocumentGridValue, id: new Date().getTime() },
      ]),
    );
    dispatch(setDcumentExtra(null));
    dispatch(setDocumentoInfo(null));
    dispatch(setDocumentiB2b_extra([]));
    dispatch(setDocumentiB2b_adg([]));
    dispatch(setTabella(''));
    dispatch(setLoading(false));
  };
};

export const duplicateDocument = newDocument;

let lastRequestController: AbortController | null = null;

export const fetchDocumentiRicerca = (
  paginate: boolean,
  tabella: string,
  page: number,
  filiale: string,
  ragioneSociale?: string,
  numeroDocumento?: string,
  data?: string,
  meseSelezionato?: number,
) => {
  return (dispatch: AppDispatch) => {
    const pageSize = 25;

    if (lastRequestController) {
      lastRequestController.abort();
    }

    // Crea un nuovo AbortController
    lastRequestController = new AbortController();
    const signal = lastRequestController.signal;

    // Costruzione filtri di base
    const arrayFilters: any[] = [
      {
        property: 'filiale',
        operator: '=',
        value: filiale,
      },
      {
        property: 'data',
        operator: '>',
        date: true,
        value: new Date(0),
      },
    ];

    if (data) {
      const newDate = new Date(data);
      const year = newDate.getFullYear();

      let firstDay: Date;
      let lastDay: Date;

      if (meseSelezionato === undefined || meseSelezionato === null) {
        firstDay = new Date(year, 0, 1); // Inizio anno
        lastDay = new Date(year, 11, 31, 23, 59, 59); // Fine anno
      } else {
        firstDay = new Date(year, meseSelezionato, 1); // Inizio mese
        lastDay = new Date(year, meseSelezionato + 1, 0, 23, 59, 59); // Fine mese
      }

      arrayFilters.push(
        {
          operator: '>=',
          property: 'data',
          value: firstDay,
          date: true,
        },
        {
          operator: '<=',
          property: 'data',
          value: lastDay,
          date: true,
        },
      );
    }

    // Aggiunge filtri opzionali
    if (ragioneSociale) {
      arrayFilters.push({
        property: 'ragioneSociale',
        value: ragioneSociale,
        operator: 'fulltext',
      });
    }

    if (numeroDocumento) {
      arrayFilters.push({
        property: 'numero',
        value: numeroDocumento,
        operator: 'fulltext',
      });
    }
    dispatch(setLoading(true));

    axios
      .get(`/focusapi/documento/getDocumentiRicerca`, {
        params: {
          _dc: new Date().getTime(),
          tablename: tabella,
          ...getTablePaginationRequestProps(page, pageSize),
          sort: JSON.stringify([
            {
              property: 'filiale',
              direction: 'DESC',
            },
            {
              property: 'data',
              direction: 'DESC',
            },
            {
              property: 'id',
              direction: 'DESC',
            },
          ]),
          filter: filiale === '-1' ? undefined : JSON.stringify(arrayFilters),
        },
        signal, // Passa il segnale di abort alla richiesta
      })
      .then((response) => {
        dispatch(
          setRicercaFatturaList({
            data: response.data.Documenti || [],
            totale: response.data.Total || 0,
          }),
        );
        dispatch(setLoading(false));
      })
      .catch((err) => {
        dispatch(setLoading(false));
        dispatch(setError(err ? err : 'Internal server error'));
      })
      .finally(() => {
        // Resetta il controller dopo la richiesta;
        lastRequestController = null;
      });
  };
};

export const saveDocument = (
  nome: string,
  documento: Documentzero_table_interface[],
  righe: Documentzero__table_interface[],
) => {
  return (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    axios
      .post('/focusapi/documenti/salvadocumento', {
        nome: nome,
        documento: documento[0],
        righe: righe,
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const {
  setDocument,
  setCastellettoIva,
  setDocumentList,
  setDcumentExtra,
  setDocumentoInfo,
  setDocumentiB2b_extra,
  setDocumentiB2b_adg,
  setPage,
  setRicercaFatturaList,
  setTabella,
  setError,
  setLoading,
  setDocumentSchema,
  setDatagridSchema,
  setDocumentTipo,
  setDocumentoTotal,
  resetDocumentoInitialState,
  toggleEdit,
  setConfigurazioneDocumento,
  setPreventDatagridEdit,
  setFiliale,
  setSistemaTesseraSanitaria,
  setConsoleTelematica,
  setConsoleTelematicaFE,
  setRicercaDataAnno,
  setRicercaMonthSelected,
  setRicercaNumeroDocumento,
  setRicercaRagioneSociale,
} = DocumentiSlice.actions;

export default DocumentiSlice.reducer;
